import {
  BrowserRouter as Router,
  Switch,
  Route,
  useRouteMatch,
} from "react-router-dom";
import DashboardIndex from "./Index";
import "bootstrap/dist/css/bootstrap.min.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUserCircle,
  faSignOutAlt,
  faFileAlt,
} from "@fortawesome/free-solid-svg-icons";
import TopHeader from "../layout/TopHeader";
import { getUserRole } from "../utils/index";
import DashboardSideMenu from "./DashboardSideMenu";
import BottomNav from "../layout/BottomNav";

export default function Dashboard() {
  let match = useRouteMatch();

  return (
    <div>
      <TopHeader />
      <div className="masterContainer">
        <>
          {/* <DashboardSideMenu /> */}
          <Switch>
            <Route path={`/`}>
              <DashboardIndex />
            </Route>
          </Switch>
          <BottomNav />
        </>
      </div>
    </div>
  );
}
